@if (showDashboard()) {
<div class="mobile-dashboard-nav w-full">
    <div class="grid mt-1">

        @for (menuItem of menuItems(); track menuItem.label) {
            @if (menuItem.visible !== false) {
                <div class=" col-12 sm:col-6">
                    <a
                        pButton
                        class="dashboard-nav-button flex justify-content-between"
                        [routerLink]="['/', menuItem.routerLink]"
                    >
                        <span class="flex align-items-center">
                            <span class="dashboard-nav-icon">
                                <i [class]="menuItem.icon"></i>
                            </span>

                            <span class="dashboard-nav-label">
                                {{ menuItem.label }}
                            </span>
                        </span>
                        @if (menuItem.badge ) {
                            <span class="dashboard-nav-badge">
                                <p-badge [value]="menuItem.badge" severity="warn" size="xlarge" />
                            </span>
                        }
                    </a>
                </div>
            }
        }

    </div>
</div>
}
